"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IAdd", {
  enumerable: true,
  get: function get() {
    return _IAdd["default"];
  }
});
Object.defineProperty(exports, "IAddOutlined", {
  enumerable: true,
  get: function get() {
    return _IAddOutlined["default"];
  }
});
Object.defineProperty(exports, "IArrowLeft", {
  enumerable: true,
  get: function get() {
    return _IArrowLeft["default"];
  }
});
Object.defineProperty(exports, "IArrowRight", {
  enumerable: true,
  get: function get() {
    return _IArrowRight["default"];
  }
});
Object.defineProperty(exports, "IAudio", {
  enumerable: true,
  get: function get() {
    return _IAudio["default"];
  }
});
Object.defineProperty(exports, "IAuthor", {
  enumerable: true,
  get: function get() {
    return _IAuthor["default"];
  }
});
Object.defineProperty(exports, "IBadge", {
  enumerable: true,
  get: function get() {
    return _IBadge["default"];
  }
});
Object.defineProperty(exports, "IBadgeOutlined", {
  enumerable: true,
  get: function get() {
    return _IBadgeOutlined["default"];
  }
});
Object.defineProperty(exports, "IBook", {
  enumerable: true,
  get: function get() {
    return _IBook["default"];
  }
});
Object.defineProperty(exports, "IBookOutlined", {
  enumerable: true,
  get: function get() {
    return _IBookOutlined["default"];
  }
});
Object.defineProperty(exports, "IBookmark", {
  enumerable: true,
  get: function get() {
    return _IBookmark["default"];
  }
});
Object.defineProperty(exports, "IBookmarkOutlined", {
  enumerable: true,
  get: function get() {
    return _IBookmarkOutlined["default"];
  }
});
Object.defineProperty(exports, "IBrighternessHigh", {
  enumerable: true,
  get: function get() {
    return _IBrighternessHigh["default"];
  }
});
Object.defineProperty(exports, "IBrighternessHighOutlined", {
  enumerable: true,
  get: function get() {
    return _IBrighternessHighOutlined["default"];
  }
});
Object.defineProperty(exports, "IBrighternessLow", {
  enumerable: true,
  get: function get() {
    return _IBrighternessLow["default"];
  }
});
Object.defineProperty(exports, "IBrighternessLowOutlined", {
  enumerable: true,
  get: function get() {
    return _IBrighternessLowOutlined["default"];
  }
});
Object.defineProperty(exports, "IBulletOff", {
  enumerable: true,
  get: function get() {
    return _IBulletOff["default"];
  }
});
Object.defineProperty(exports, "IBulletOffOutlined", {
  enumerable: true,
  get: function get() {
    return _IBulletOffOutlined["default"];
  }
});
Object.defineProperty(exports, "IBulletOn", {
  enumerable: true,
  get: function get() {
    return _IBulletOn["default"];
  }
});
Object.defineProperty(exports, "IBulletOnOutlined", {
  enumerable: true,
  get: function get() {
    return _IBulletOnOutlined["default"];
  }
});
Object.defineProperty(exports, "ICalendar", {
  enumerable: true,
  get: function get() {
    return _ICalendar["default"];
  }
});
Object.defineProperty(exports, "ICalendarCheickIn", {
  enumerable: true,
  get: function get() {
    return _ICalendarCheickIn["default"];
  }
});
Object.defineProperty(exports, "ICalendarCheickInOutlined", {
  enumerable: true,
  get: function get() {
    return _ICalendarCheickInOutlined["default"];
  }
});
Object.defineProperty(exports, "ICalendarOutlined", {
  enumerable: true,
  get: function get() {
    return _ICalendarOutlined["default"];
  }
});
Object.defineProperty(exports, "ICamera", {
  enumerable: true,
  get: function get() {
    return _ICamera["default"];
  }
});
Object.defineProperty(exports, "ICameraOutlined", {
  enumerable: true,
  get: function get() {
    return _ICameraOutlined["default"];
  }
});
Object.defineProperty(exports, "IChapter", {
  enumerable: true,
  get: function get() {
    return _IChapter["default"];
  }
});
Object.defineProperty(exports, "IChapterComment", {
  enumerable: true,
  get: function get() {
    return _IChapterComment["default"];
  }
});
Object.defineProperty(exports, "IChapterCommentOutlined", {
  enumerable: true,
  get: function get() {
    return _IChapterCommentOutlined["default"];
  }
});
Object.defineProperty(exports, "IChapterOutlined", {
  enumerable: true,
  get: function get() {
    return _IChapterOutlined["default"];
  }
});
Object.defineProperty(exports, "IChart", {
  enumerable: true,
  get: function get() {
    return _IChart["default"];
  }
});
Object.defineProperty(exports, "ICheckbox", {
  enumerable: true,
  get: function get() {
    return _ICheckbox["default"];
  }
});
Object.defineProperty(exports, "ICheckboxChecked", {
  enumerable: true,
  get: function get() {
    return _ICheckboxChecked["default"];
  }
});
Object.defineProperty(exports, "ICheckboxCheckedOutlined", {
  enumerable: true,
  get: function get() {
    return _ICheckboxCheckedOutlined["default"];
  }
});
Object.defineProperty(exports, "ICheckboxMinus", {
  enumerable: true,
  get: function get() {
    return _ICheckboxMinus["default"];
  }
});
Object.defineProperty(exports, "ICheckboxMinusOutlined", {
  enumerable: true,
  get: function get() {
    return _ICheckboxMinusOutlined["default"];
  }
});
Object.defineProperty(exports, "ICheckmark", {
  enumerable: true,
  get: function get() {
    return _ICheckmark["default"];
  }
});
Object.defineProperty(exports, "ICheckmarkSmall", {
  enumerable: true,
  get: function get() {
    return _ICheckmarkSmall["default"];
  }
});
Object.defineProperty(exports, "IChevronDown", {
  enumerable: true,
  get: function get() {
    return _IChevronDown["default"];
  }
});
Object.defineProperty(exports, "IChevronLeft", {
  enumerable: true,
  get: function get() {
    return _IChevronLeft["default"];
  }
});
Object.defineProperty(exports, "IChevronRight", {
  enumerable: true,
  get: function get() {
    return _IChevronRight["default"];
  }
});
Object.defineProperty(exports, "IChevronUp", {
  enumerable: true,
  get: function get() {
    return _IChevronUp["default"];
  }
});
Object.defineProperty(exports, "IClear", {
  enumerable: true,
  get: function get() {
    return _IClear["default"];
  }
});
Object.defineProperty(exports, "IClearOutlined", {
  enumerable: true,
  get: function get() {
    return _IClearOutlined["default"];
  }
});
Object.defineProperty(exports, "IClock", {
  enumerable: true,
  get: function get() {
    return _IClock["default"];
  }
});
Object.defineProperty(exports, "IClockOutlined", {
  enumerable: true,
  get: function get() {
    return _IClockOutlined["default"];
  }
});
Object.defineProperty(exports, "ICloud", {
  enumerable: true,
  get: function get() {
    return _ICloud["default"];
  }
});
Object.defineProperty(exports, "ICloudOutlined", {
  enumerable: true,
  get: function get() {
    return _ICloudOutlined["default"];
  }
});
Object.defineProperty(exports, "ICollapse", {
  enumerable: true,
  get: function get() {
    return _ICollapse["default"];
  }
});
Object.defineProperty(exports, "IComic", {
  enumerable: true,
  get: function get() {
    return _IComic["default"];
  }
});
Object.defineProperty(exports, "IComicOutlined", {
  enumerable: true,
  get: function get() {
    return _IComicOutlined["default"];
  }
});
Object.defineProperty(exports, "IComment", {
  enumerable: true,
  get: function get() {
    return _IComment["default"];
  }
});
Object.defineProperty(exports, "ICommentOutlined", {
  enumerable: true,
  get: function get() {
    return _ICommentOutlined["default"];
  }
});
Object.defineProperty(exports, "ICommentRemove", {
  enumerable: true,
  get: function get() {
    return _ICommentRemove["default"];
  }
});
Object.defineProperty(exports, "ICommentRemoveOutlined", {
  enumerable: true,
  get: function get() {
    return _ICommentRemoveOutlined["default"];
  }
});
Object.defineProperty(exports, "ICommentReply", {
  enumerable: true,
  get: function get() {
    return _ICommentReply["default"];
  }
});
Object.defineProperty(exports, "ICommentReplyOutlined", {
  enumerable: true,
  get: function get() {
    return _ICommentReplyOutlined["default"];
  }
});
Object.defineProperty(exports, "IContent", {
  enumerable: true,
  get: function get() {
    return _IContent["default"];
  }
});
Object.defineProperty(exports, "IContents", {
  enumerable: true,
  get: function get() {
    return _IContents["default"];
  }
});
Object.defineProperty(exports, "IContentsOutlined", {
  enumerable: true,
  get: function get() {
    return _IContentsOutlined["default"];
  }
});
Object.defineProperty(exports, "IContentsRemove", {
  enumerable: true,
  get: function get() {
    return _IContentsRemove["default"];
  }
});
Object.defineProperty(exports, "IContentsRemoveOutlined", {
  enumerable: true,
  get: function get() {
    return _IContentsRemoveOutlined["default"];
  }
});
Object.defineProperty(exports, "ICountdown", {
  enumerable: true,
  get: function get() {
    return _ICountdown["default"];
  }
});
Object.defineProperty(exports, "ICountdownOutlined", {
  enumerable: true,
  get: function get() {
    return _ICountdownOutlined["default"];
  }
});
Object.defineProperty(exports, "ICup", {
  enumerable: true,
  get: function get() {
    return _ICup["default"];
  }
});
Object.defineProperty(exports, "IDarkness", {
  enumerable: true,
  get: function get() {
    return _IDarkness["default"];
  }
});
Object.defineProperty(exports, "IDarknessOutlined", {
  enumerable: true,
  get: function get() {
    return _IDarknessOutlined["default"];
  }
});
Object.defineProperty(exports, "IDelete", {
  enumerable: true,
  get: function get() {
    return _IDelete["default"];
  }
});
Object.defineProperty(exports, "IDeleteOutlined", {
  enumerable: true,
  get: function get() {
    return _IDeleteOutlined["default"];
  }
});
Object.defineProperty(exports, "IDiscount", {
  enumerable: true,
  get: function get() {
    return _IDiscount["default"];
  }
});
Object.defineProperty(exports, "IDiscountOutlined", {
  enumerable: true,
  get: function get() {
    return _IDiscountOutlined["default"];
  }
});
Object.defineProperty(exports, "IDiscountTag", {
  enumerable: true,
  get: function get() {
    return _IDiscountTag["default"];
  }
});
Object.defineProperty(exports, "IDiscountTagOutlined", {
  enumerable: true,
  get: function get() {
    return _IDiscountTagOutlined["default"];
  }
});
Object.defineProperty(exports, "IDislike", {
  enumerable: true,
  get: function get() {
    return _IDislike["default"];
  }
});
Object.defineProperty(exports, "IDislikeOutlined", {
  enumerable: true,
  get: function get() {
    return _IDislikeOutlined["default"];
  }
});
Object.defineProperty(exports, "IDownload", {
  enumerable: true,
  get: function get() {
    return _IDownload["default"];
  }
});
Object.defineProperty(exports, "IDownloadOutlined", {
  enumerable: true,
  get: function get() {
    return _IDownloadOutlined["default"];
  }
});
Object.defineProperty(exports, "IEarth", {
  enumerable: true,
  get: function get() {
    return _IEarth["default"];
  }
});
Object.defineProperty(exports, "IEarthOutlined", {
  enumerable: true,
  get: function get() {
    return _IEarthOutlined["default"];
  }
});
Object.defineProperty(exports, "IEmail", {
  enumerable: true,
  get: function get() {
    return _IEmail["default"];
  }
});
Object.defineProperty(exports, "IEmailOutlined", {
  enumerable: true,
  get: function get() {
    return _IEmailOutlined["default"];
  }
});
Object.defineProperty(exports, "IExp", {
  enumerable: true,
  get: function get() {
    return _IExp["default"];
  }
});
Object.defineProperty(exports, "IExpOutlined", {
  enumerable: true,
  get: function get() {
    return _IExpOutlined["default"];
  }
});
Object.defineProperty(exports, "IExpand", {
  enumerable: true,
  get: function get() {
    return _IExpand["default"];
  }
});
Object.defineProperty(exports, "IFastpass", {
  enumerable: true,
  get: function get() {
    return _IFastpass["default"];
  }
});
Object.defineProperty(exports, "IFlag", {
  enumerable: true,
  get: function get() {
    return _IFlag["default"];
  }
});
Object.defineProperty(exports, "IFollowList", {
  enumerable: true,
  get: function get() {
    return _IFollowList["default"];
  }
});
Object.defineProperty(exports, "IFollowListOutlined", {
  enumerable: true,
  get: function get() {
    return _IFollowListOutlined["default"];
  }
});
Object.defineProperty(exports, "IFollowedList", {
  enumerable: true,
  get: function get() {
    return _IFollowedList["default"];
  }
});
Object.defineProperty(exports, "IFontSizeDown", {
  enumerable: true,
  get: function get() {
    return _IFontSizeDown["default"];
  }
});
Object.defineProperty(exports, "IFontSizeUp", {
  enumerable: true,
  get: function get() {
    return _IFontSizeUp["default"];
  }
});
Object.defineProperty(exports, "IFrame", {
  enumerable: true,
  get: function get() {
    return _IFrame["default"];
  }
});
Object.defineProperty(exports, "IGenderFemale", {
  enumerable: true,
  get: function get() {
    return _IGenderFemale["default"];
  }
});
Object.defineProperty(exports, "IGenderMale", {
  enumerable: true,
  get: function get() {
    return _IGenderMale["default"];
  }
});
Object.defineProperty(exports, "IGenre", {
  enumerable: true,
  get: function get() {
    return _IGenre["default"];
  }
});
Object.defineProperty(exports, "IGif", {
  enumerable: true,
  get: function get() {
    return _IGif["default"];
  }
});
Object.defineProperty(exports, "IGifOutlined", {
  enumerable: true,
  get: function get() {
    return _IGifOutlined["default"];
  }
});
Object.defineProperty(exports, "IGift", {
  enumerable: true,
  get: function get() {
    return _IGift["default"];
  }
});
Object.defineProperty(exports, "IGiftOutlined", {
  enumerable: true,
  get: function get() {
    return _IGiftOutlined["default"];
  }
});
Object.defineProperty(exports, "IHashtag", {
  enumerable: true,
  get: function get() {
    return _IHashtag["default"];
  }
});
Object.defineProperty(exports, "IHashtagOutlined", {
  enumerable: true,
  get: function get() {
    return _IHashtagOutlined["default"];
  }
});
Object.defineProperty(exports, "IHeart", {
  enumerable: true,
  get: function get() {
    return _IHeart["default"];
  }
});
Object.defineProperty(exports, "IHeartOutlined", {
  enumerable: true,
  get: function get() {
    return _IHeartOutlined["default"];
  }
});
Object.defineProperty(exports, "IHelp", {
  enumerable: true,
  get: function get() {
    return _IHelp["default"];
  }
});
Object.defineProperty(exports, "IHelpOutlined", {
  enumerable: true,
  get: function get() {
    return _IHelpOutlined["default"];
  }
});
Object.defineProperty(exports, "IHighlight", {
  enumerable: true,
  get: function get() {
    return _IHighlight["default"];
  }
});
Object.defineProperty(exports, "IHighlightOutlined", {
  enumerable: true,
  get: function get() {
    return _IHighlightOutlined["default"];
  }
});
Object.defineProperty(exports, "IHighlightRemove", {
  enumerable: true,
  get: function get() {
    return _IHighlightRemove["default"];
  }
});
Object.defineProperty(exports, "IHighlightRemoveOutlined", {
  enumerable: true,
  get: function get() {
    return _IHighlightRemoveOutlined["default"];
  }
});
Object.defineProperty(exports, "IHot", {
  enumerable: true,
  get: function get() {
    return _IHot["default"];
  }
});
Object.defineProperty(exports, "IHot2", {
  enumerable: true,
  get: function get() {
    return _IHot2["default"];
  }
});
Object.defineProperty(exports, "IHot2Outlined", {
  enumerable: true,
  get: function get() {
    return _IHot2Outlined["default"];
  }
});
Object.defineProperty(exports, "IHotOutlined", {
  enumerable: true,
  get: function get() {
    return _IHotOutlined["default"];
  }
});
Object.defineProperty(exports, "IId", {
  enumerable: true,
  get: function get() {
    return _IId["default"];
  }
});
Object.defineProperty(exports, "IIdOutlined", {
  enumerable: true,
  get: function get() {
    return _IIdOutlined["default"];
  }
});
Object.defineProperty(exports, "IImage", {
  enumerable: true,
  get: function get() {
    return _IImage["default"];
  }
});
Object.defineProperty(exports, "IImageOff", {
  enumerable: true,
  get: function get() {
    return _IImageOff["default"];
  }
});
Object.defineProperty(exports, "IImageOffOutlined", {
  enumerable: true,
  get: function get() {
    return _IImageOffOutlined["default"];
  }
});
Object.defineProperty(exports, "IImageOutlined", {
  enumerable: true,
  get: function get() {
    return _IImageOutlined["default"];
  }
});
Object.defineProperty(exports, "IInbox", {
  enumerable: true,
  get: function get() {
    return _IInbox["default"];
  }
});
Object.defineProperty(exports, "IInboxOutlined", {
  enumerable: true,
  get: function get() {
    return _IInboxOutlined["default"];
  }
});
Object.defineProperty(exports, "IKeyboard", {
  enumerable: true,
  get: function get() {
    return _IKeyboard["default"];
  }
});
Object.defineProperty(exports, "IKeyboardOutlined", {
  enumerable: true,
  get: function get() {
    return _IKeyboardOutlined["default"];
  }
});
Object.defineProperty(exports, "ILanguage", {
  enumerable: true,
  get: function get() {
    return _ILanguage["default"];
  }
});
Object.defineProperty(exports, "ILevel", {
  enumerable: true,
  get: function get() {
    return _ILevel["default"];
  }
});
Object.defineProperty(exports, "ILevelOutlined", {
  enumerable: true,
  get: function get() {
    return _ILevelOutlined["default"];
  }
});
Object.defineProperty(exports, "ILink", {
  enumerable: true,
  get: function get() {
    return _ILink["default"];
  }
});
Object.defineProperty(exports, "ILock", {
  enumerable: true,
  get: function get() {
    return _ILock["default"];
  }
});
Object.defineProperty(exports, "ILockOutlined", {
  enumerable: true,
  get: function get() {
    return _ILockOutlined["default"];
  }
});
Object.defineProperty(exports, "ILogo", {
  enumerable: true,
  get: function get() {
    return _ILogo["default"];
  }
});
Object.defineProperty(exports, "IMax", {
  enumerable: true,
  get: function get() {
    return _IMax["default"];
  }
});
Object.defineProperty(exports, "IMedal", {
  enumerable: true,
  get: function get() {
    return _IMedal["default"];
  }
});
Object.defineProperty(exports, "IMedalOutlined", {
  enumerable: true,
  get: function get() {
    return _IMedalOutlined["default"];
  }
});
Object.defineProperty(exports, "IMin", {
  enumerable: true,
  get: function get() {
    return _IMin["default"];
  }
});
Object.defineProperty(exports, "IMobile", {
  enumerable: true,
  get: function get() {
    return _IMobile["default"];
  }
});
Object.defineProperty(exports, "IMobileOutlined", {
  enumerable: true,
  get: function get() {
    return _IMobileOutlined["default"];
  }
});
Object.defineProperty(exports, "IMoreHoriz", {
  enumerable: true,
  get: function get() {
    return _IMoreHoriz["default"];
  }
});
Object.defineProperty(exports, "IMoreVert", {
  enumerable: true,
  get: function get() {
    return _IMoreVert["default"];
  }
});
Object.defineProperty(exports, "IMultipleSelect", {
  enumerable: true,
  get: function get() {
    return _IMultipleSelect["default"];
  }
});
Object.defineProperty(exports, "IMultipleSelectOutlined", {
  enumerable: true,
  get: function get() {
    return _IMultipleSelectOutlined["default"];
  }
});
Object.defineProperty(exports, "INotifiction", {
  enumerable: true,
  get: function get() {
    return _INotifiction["default"];
  }
});
Object.defineProperty(exports, "INotifictionOutlined", {
  enumerable: true,
  get: function get() {
    return _INotifictionOutlined["default"];
  }
});
Object.defineProperty(exports, "INovel", {
  enumerable: true,
  get: function get() {
    return _INovel["default"];
  }
});
Object.defineProperty(exports, "INovelOutlined", {
  enumerable: true,
  get: function get() {
    return _INovelOutlined["default"];
  }
});
Object.defineProperty(exports, "IOutlined", {
  enumerable: true,
  get: function get() {
    return _IOutlined["default"];
  }
});
Object.defineProperty(exports, "IParagraphComment", {
  enumerable: true,
  get: function get() {
    return _IParagraphComment["default"];
  }
});
Object.defineProperty(exports, "IPause", {
  enumerable: true,
  get: function get() {
    return _IPause["default"];
  }
});
Object.defineProperty(exports, "IPen", {
  enumerable: true,
  get: function get() {
    return _IPen["default"];
  }
});
Object.defineProperty(exports, "IPenOutline", {
  enumerable: true,
  get: function get() {
    return _IPenOutline["default"];
  }
});
Object.defineProperty(exports, "IPerson", {
  enumerable: true,
  get: function get() {
    return _IPerson["default"];
  }
});
Object.defineProperty(exports, "IPickbook", {
  enumerable: true,
  get: function get() {
    return _IPickbook["default"];
  }
});
Object.defineProperty(exports, "IPickbookOutlined", {
  enumerable: true,
  get: function get() {
    return _IPickbookOutlined["default"];
  }
});
Object.defineProperty(exports, "IPin", {
  enumerable: true,
  get: function get() {
    return _IPin["default"];
  }
});
Object.defineProperty(exports, "IPinMap", {
  enumerable: true,
  get: function get() {
    return _IPinMap["default"];
  }
});
Object.defineProperty(exports, "IPinRemove", {
  enumerable: true,
  get: function get() {
    return _IPinRemove["default"];
  }
});
Object.defineProperty(exports, "IPlus", {
  enumerable: true,
  get: function get() {
    return _IPlus["default"];
  }
});
Object.defineProperty(exports, "IPoint", {
  enumerable: true,
  get: function get() {
    return _IPoint["default"];
  }
});
Object.defineProperty(exports, "IPointOutlined", {
  enumerable: true,
  get: function get() {
    return _IPointOutlined["default"];
  }
});
Object.defineProperty(exports, "IPolygonDown", {
  enumerable: true,
  get: function get() {
    return _IPolygonDown["default"];
  }
});
Object.defineProperty(exports, "IPolygonDownOutlined", {
  enumerable: true,
  get: function get() {
    return _IPolygonDownOutlined["default"];
  }
});
Object.defineProperty(exports, "IPolygonLeft", {
  enumerable: true,
  get: function get() {
    return _IPolygonLeft["default"];
  }
});
Object.defineProperty(exports, "IPolygonLeftOutlined", {
  enumerable: true,
  get: function get() {
    return _IPolygonLeftOutlined["default"];
  }
});
Object.defineProperty(exports, "IPolygonRight", {
  enumerable: true,
  get: function get() {
    return _IPolygonRight["default"];
  }
});
Object.defineProperty(exports, "IPolygonUp", {
  enumerable: true,
  get: function get() {
    return _IPolygonUp["default"];
  }
});
Object.defineProperty(exports, "IPolygonUpOutlined", {
  enumerable: true,
  get: function get() {
    return _IPolygonUpOutlined["default"];
  }
});
Object.defineProperty(exports, "IPrivilege", {
  enumerable: true,
  get: function get() {
    return _IPrivilege["default"];
  }
});
Object.defineProperty(exports, "IPrivilegeOutlined", {
  enumerable: true,
  get: function get() {
    return _IPrivilegeOutlined["default"];
  }
});
Object.defineProperty(exports, "IQuestion", {
  enumerable: true,
  get: function get() {
    return _IQuestion["default"];
  }
});
Object.defineProperty(exports, "IQuestionOutline", {
  enumerable: true,
  get: function get() {
    return _IQuestionOutline["default"];
  }
});
Object.defineProperty(exports, "IRadioSelected", {
  enumerable: true,
  get: function get() {
    return _IRadioSelected["default"];
  }
});
Object.defineProperty(exports, "IRadioSelectedOutlined", {
  enumerable: true,
  get: function get() {
    return _IRadioSelectedOutlined["default"];
  }
});
Object.defineProperty(exports, "IRadioUnselected", {
  enumerable: true,
  get: function get() {
    return _IRadioUnselected["default"];
  }
});
Object.defineProperty(exports, "IRankUp", {
  enumerable: true,
  get: function get() {
    return _IRankUp["default"];
  }
});
Object.defineProperty(exports, "IReadHistory", {
  enumerable: true,
  get: function get() {
    return _IReadHistory["default"];
  }
});
Object.defineProperty(exports, "IReadHistoryOutlined", {
  enumerable: true,
  get: function get() {
    return _IReadHistoryOutlined["default"];
  }
});
Object.defineProperty(exports, "IReadPage", {
  enumerable: true,
  get: function get() {
    return _IReadPage["default"];
  }
});
Object.defineProperty(exports, "IReadPageOutlined", {
  enumerable: true,
  get: function get() {
    return _IReadPageOutlined["default"];
  }
});
Object.defineProperty(exports, "IReadScroll", {
  enumerable: true,
  get: function get() {
    return _IReadScroll["default"];
  }
});
Object.defineProperty(exports, "IReadScrollOutlined", {
  enumerable: true,
  get: function get() {
    return _IReadScrollOutlined["default"];
  }
});
Object.defineProperty(exports, "IReadTap", {
  enumerable: true,
  get: function get() {
    return _IReadTap["default"];
  }
});
Object.defineProperty(exports, "IRedeem", {
  enumerable: true,
  get: function get() {
    return _IRedeem["default"];
  }
});
Object.defineProperty(exports, "IRefresh", {
  enumerable: true,
  get: function get() {
    return _IRefresh["default"];
  }
});
Object.defineProperty(exports, "IReport", {
  enumerable: true,
  get: function get() {
    return _IReport["default"];
  }
});
Object.defineProperty(exports, "IReportOutlined", {
  enumerable: true,
  get: function get() {
    return _IReportOutlined["default"];
  }
});
Object.defineProperty(exports, "ISearch", {
  enumerable: true,
  get: function get() {
    return _ISearch["default"];
  }
});
Object.defineProperty(exports, "ISetting", {
  enumerable: true,
  get: function get() {
    return _ISetting["default"];
  }
});
Object.defineProperty(exports, "ISettingOutlined", {
  enumerable: true,
  get: function get() {
    return _ISettingOutlined["default"];
  }
});
Object.defineProperty(exports, "IShare", {
  enumerable: true,
  get: function get() {
    return _IShare["default"];
  }
});
Object.defineProperty(exports, "IShareOutlined", {
  enumerable: true,
  get: function get() {
    return _IShareOutlined["default"];
  }
});
Object.defineProperty(exports, "IShowOff", {
  enumerable: true,
  get: function get() {
    return _IShowOff["default"];
  }
});
Object.defineProperty(exports, "IShowOffOutlined", {
  enumerable: true,
  get: function get() {
    return _IShowOffOutlined["default"];
  }
});
Object.defineProperty(exports, "IShowOn", {
  enumerable: true,
  get: function get() {
    return _IShowOn["default"];
  }
});
Object.defineProperty(exports, "IShowOnOutlined", {
  enumerable: true,
  get: function get() {
    return _IShowOnOutlined["default"];
  }
});
Object.defineProperty(exports, "ISmile", {
  enumerable: true,
  get: function get() {
    return _ISmile["default"];
  }
});
Object.defineProperty(exports, "ISmileOutlined", {
  enumerable: true,
  get: function get() {
    return _ISmileOutlined["default"];
  }
});
Object.defineProperty(exports, "ISpeaker", {
  enumerable: true,
  get: function get() {
    return _ISpeaker["default"];
  }
});
Object.defineProperty(exports, "IStar", {
  enumerable: true,
  get: function get() {
    return _IStar["default"];
  }
});
Object.defineProperty(exports, "IStarHalfLeft", {
  enumerable: true,
  get: function get() {
    return _IStarHalfLeft["default"];
  }
});
Object.defineProperty(exports, "IStarHalfLeftOutlined", {
  enumerable: true,
  get: function get() {
    return _IStarHalfLeftOutlined["default"];
  }
});
Object.defineProperty(exports, "IStarHalfRight", {
  enumerable: true,
  get: function get() {
    return _IStarHalfRight["default"];
  }
});
Object.defineProperty(exports, "IStarHalfRightOutlined", {
  enumerable: true,
  get: function get() {
    return _IStarHalfRightOutlined["default"];
  }
});
Object.defineProperty(exports, "IStarOutlined", {
  enumerable: true,
  get: function get() {
    return _IStarOutlined["default"];
  }
});
Object.defineProperty(exports, "IStoneEnergy", {
  enumerable: true,
  get: function get() {
    return _IStoneEnergy["default"];
  }
});
Object.defineProperty(exports, "IStonePower", {
  enumerable: true,
  get: function get() {
    return _IStonePower["default"];
  }
});
Object.defineProperty(exports, "ISwitch", {
  enumerable: true,
  get: function get() {
    return _ISwitch["default"];
  }
});
Object.defineProperty(exports, "ISync", {
  enumerable: true,
  get: function get() {
    return _ISync["default"];
  }
});
Object.defineProperty(exports, "ISyncOutlined", {
  enumerable: true,
  get: function get() {
    return _ISyncOutlined["default"];
  }
});
Object.defineProperty(exports, "ITap", {
  enumerable: true,
  get: function get() {
    return _ITap["default"];
  }
});
Object.defineProperty(exports, "ITapOutlined", {
  enumerable: true,
  get: function get() {
    return _ITapOutlined["default"];
  }
});
Object.defineProperty(exports, "IUnlock", {
  enumerable: true,
  get: function get() {
    return _IUnlock["default"];
  }
});
Object.defineProperty(exports, "IUnlockBatch", {
  enumerable: true,
  get: function get() {
    return _IUnlockBatch["default"];
  }
});
Object.defineProperty(exports, "IUnlockOutlined", {
  enumerable: true,
  get: function get() {
    return _IUnlockOutlined["default"];
  }
});
Object.defineProperty(exports, "IUpvote", {
  enumerable: true,
  get: function get() {
    return _IUpvote["default"];
  }
});
Object.defineProperty(exports, "IUpvoteOutlined", {
  enumerable: true,
  get: function get() {
    return _IUpvoteOutlined["default"];
  }
});
Object.defineProperty(exports, "IVoucher", {
  enumerable: true,
  get: function get() {
    return _IVoucher["default"];
  }
});
Object.defineProperty(exports, "IVoucherOutlined", {
  enumerable: true,
  get: function get() {
    return _IVoucherOutlined["default"];
  }
});
Object.defineProperty(exports, "IX", {
  enumerable: true,
  get: function get() {
    return _IX["default"];
  }
});

var _IAdd = _interopRequireDefault(require("./icons/IAdd"));

var _IAddOutlined = _interopRequireDefault(require("./icons/IAddOutlined"));

var _IArrowLeft = _interopRequireDefault(require("./icons/IArrowLeft"));

var _IArrowRight = _interopRequireDefault(require("./icons/IArrowRight"));

var _IAudio = _interopRequireDefault(require("./icons/IAudio"));

var _IAuthor = _interopRequireDefault(require("./icons/IAuthor"));

var _IBadge = _interopRequireDefault(require("./icons/IBadge"));

var _IBadgeOutlined = _interopRequireDefault(require("./icons/IBadgeOutlined"));

var _IBook = _interopRequireDefault(require("./icons/IBook"));

var _IBookOutlined = _interopRequireDefault(require("./icons/IBookOutlined"));

var _IBookmark = _interopRequireDefault(require("./icons/IBookmark"));

var _IBookmarkOutlined = _interopRequireDefault(require("./icons/IBookmarkOutlined"));

var _IBrighternessHigh = _interopRequireDefault(require("./icons/IBrighternessHigh"));

var _IBrighternessHighOutlined = _interopRequireDefault(require("./icons/IBrighternessHighOutlined"));

var _IBrighternessLow = _interopRequireDefault(require("./icons/IBrighternessLow"));

var _IBrighternessLowOutlined = _interopRequireDefault(require("./icons/IBrighternessLowOutlined"));

var _IBulletOff = _interopRequireDefault(require("./icons/IBulletOff"));

var _IBulletOffOutlined = _interopRequireDefault(require("./icons/IBulletOffOutlined"));

var _IBulletOn = _interopRequireDefault(require("./icons/IBulletOn"));

var _IBulletOnOutlined = _interopRequireDefault(require("./icons/IBulletOnOutlined"));

var _ICalendar = _interopRequireDefault(require("./icons/ICalendar"));

var _ICalendarCheickIn = _interopRequireDefault(require("./icons/ICalendarCheickIn"));

var _ICalendarCheickInOutlined = _interopRequireDefault(require("./icons/ICalendarCheickInOutlined"));

var _ICalendarOutlined = _interopRequireDefault(require("./icons/ICalendarOutlined"));

var _ICamera = _interopRequireDefault(require("./icons/ICamera"));

var _ICameraOutlined = _interopRequireDefault(require("./icons/ICameraOutlined"));

var _IChapter = _interopRequireDefault(require("./icons/IChapter"));

var _IChapterComment = _interopRequireDefault(require("./icons/IChapterComment"));

var _IChapterCommentOutlined = _interopRequireDefault(require("./icons/IChapterCommentOutlined"));

var _IChapterOutlined = _interopRequireDefault(require("./icons/IChapterOutlined"));

var _IChart = _interopRequireDefault(require("./icons/IChart"));

var _ICheckbox = _interopRequireDefault(require("./icons/ICheckbox"));

var _ICheckboxChecked = _interopRequireDefault(require("./icons/ICheckboxChecked"));

var _ICheckboxCheckedOutlined = _interopRequireDefault(require("./icons/ICheckboxCheckedOutlined"));

var _ICheckboxMinus = _interopRequireDefault(require("./icons/ICheckboxMinus"));

var _ICheckboxMinusOutlined = _interopRequireDefault(require("./icons/ICheckboxMinusOutlined"));

var _ICheckmark = _interopRequireDefault(require("./icons/ICheckmark"));

var _ICheckmarkSmall = _interopRequireDefault(require("./icons/ICheckmarkSmall"));

var _IChevronDown = _interopRequireDefault(require("./icons/IChevronDown"));

var _IChevronLeft = _interopRequireDefault(require("./icons/IChevronLeft"));

var _IChevronRight = _interopRequireDefault(require("./icons/IChevronRight"));

var _IChevronUp = _interopRequireDefault(require("./icons/IChevronUp"));

var _IClear = _interopRequireDefault(require("./icons/IClear"));

var _IClearOutlined = _interopRequireDefault(require("./icons/IClearOutlined"));

var _IClock = _interopRequireDefault(require("./icons/IClock"));

var _IClockOutlined = _interopRequireDefault(require("./icons/IClockOutlined"));

var _ICloud = _interopRequireDefault(require("./icons/ICloud"));

var _ICloudOutlined = _interopRequireDefault(require("./icons/ICloudOutlined"));

var _ICollapse = _interopRequireDefault(require("./icons/ICollapse"));

var _IComic = _interopRequireDefault(require("./icons/IComic"));

var _IComicOutlined = _interopRequireDefault(require("./icons/IComicOutlined"));

var _IComment = _interopRequireDefault(require("./icons/IComment"));

var _ICommentOutlined = _interopRequireDefault(require("./icons/ICommentOutlined"));

var _ICommentRemove = _interopRequireDefault(require("./icons/ICommentRemove"));

var _ICommentRemoveOutlined = _interopRequireDefault(require("./icons/ICommentRemoveOutlined"));

var _ICommentReply = _interopRequireDefault(require("./icons/ICommentReply"));

var _ICommentReplyOutlined = _interopRequireDefault(require("./icons/ICommentReplyOutlined"));

var _IContent = _interopRequireDefault(require("./icons/IContent"));

var _IContents = _interopRequireDefault(require("./icons/IContents"));

var _IContentsOutlined = _interopRequireDefault(require("./icons/IContentsOutlined"));

var _IContentsRemove = _interopRequireDefault(require("./icons/IContentsRemove"));

var _IContentsRemoveOutlined = _interopRequireDefault(require("./icons/IContentsRemoveOutlined"));

var _ICountdown = _interopRequireDefault(require("./icons/ICountdown"));

var _ICountdownOutlined = _interopRequireDefault(require("./icons/ICountdownOutlined"));

var _ICup = _interopRequireDefault(require("./icons/ICup"));

var _IDarkness = _interopRequireDefault(require("./icons/IDarkness"));

var _IDarknessOutlined = _interopRequireDefault(require("./icons/IDarknessOutlined"));

var _IDelete = _interopRequireDefault(require("./icons/IDelete"));

var _IDeleteOutlined = _interopRequireDefault(require("./icons/IDeleteOutlined"));

var _IDiscount = _interopRequireDefault(require("./icons/IDiscount"));

var _IDiscountOutlined = _interopRequireDefault(require("./icons/IDiscountOutlined"));

var _IDiscountTag = _interopRequireDefault(require("./icons/IDiscountTag"));

var _IDiscountTagOutlined = _interopRequireDefault(require("./icons/IDiscountTagOutlined"));

var _IDislike = _interopRequireDefault(require("./icons/IDislike"));

var _IDislikeOutlined = _interopRequireDefault(require("./icons/IDislikeOutlined"));

var _IDownload = _interopRequireDefault(require("./icons/IDownload"));

var _IDownloadOutlined = _interopRequireDefault(require("./icons/IDownloadOutlined"));

var _IEarth = _interopRequireDefault(require("./icons/IEarth"));

var _IEarthOutlined = _interopRequireDefault(require("./icons/IEarthOutlined"));

var _IEmail = _interopRequireDefault(require("./icons/IEmail"));

var _IEmailOutlined = _interopRequireDefault(require("./icons/IEmailOutlined"));

var _IExp = _interopRequireDefault(require("./icons/IExp"));

var _IExpOutlined = _interopRequireDefault(require("./icons/IExpOutlined"));

var _IExpand = _interopRequireDefault(require("./icons/IExpand"));

var _IFastpass = _interopRequireDefault(require("./icons/IFastpass"));

var _IFlag = _interopRequireDefault(require("./icons/IFlag"));

var _IFollowList = _interopRequireDefault(require("./icons/IFollowList"));

var _IFollowListOutlined = _interopRequireDefault(require("./icons/IFollowListOutlined"));

var _IFollowedList = _interopRequireDefault(require("./icons/IFollowedList"));

var _IFontSizeDown = _interopRequireDefault(require("./icons/IFontSizeDown"));

var _IFontSizeUp = _interopRequireDefault(require("./icons/IFontSizeUp"));

var _IFrame = _interopRequireDefault(require("./icons/IFrame"));

var _IGenderFemale = _interopRequireDefault(require("./icons/IGenderFemale"));

var _IGenderMale = _interopRequireDefault(require("./icons/IGenderMale"));

var _IGenre = _interopRequireDefault(require("./icons/IGenre"));

var _IGif = _interopRequireDefault(require("./icons/IGif"));

var _IGifOutlined = _interopRequireDefault(require("./icons/IGifOutlined"));

var _IGift = _interopRequireDefault(require("./icons/IGift"));

var _IGiftOutlined = _interopRequireDefault(require("./icons/IGiftOutlined"));

var _IHashtag = _interopRequireDefault(require("./icons/IHashtag"));

var _IHashtagOutlined = _interopRequireDefault(require("./icons/IHashtagOutlined"));

var _IHeart = _interopRequireDefault(require("./icons/IHeart"));

var _IHeartOutlined = _interopRequireDefault(require("./icons/IHeartOutlined"));

var _IHelp = _interopRequireDefault(require("./icons/IHelp"));

var _IHelpOutlined = _interopRequireDefault(require("./icons/IHelpOutlined"));

var _IHighlight = _interopRequireDefault(require("./icons/IHighlight"));

var _IHighlightOutlined = _interopRequireDefault(require("./icons/IHighlightOutlined"));

var _IHighlightRemove = _interopRequireDefault(require("./icons/IHighlightRemove"));

var _IHighlightRemoveOutlined = _interopRequireDefault(require("./icons/IHighlightRemoveOutlined"));

var _IHot = _interopRequireDefault(require("./icons/IHot"));

var _IHot2 = _interopRequireDefault(require("./icons/IHot2"));

var _IHot2Outlined = _interopRequireDefault(require("./icons/IHot2Outlined"));

var _IHotOutlined = _interopRequireDefault(require("./icons/IHotOutlined"));

var _IId = _interopRequireDefault(require("./icons/IId"));

var _IIdOutlined = _interopRequireDefault(require("./icons/IIdOutlined"));

var _IImage = _interopRequireDefault(require("./icons/IImage"));

var _IImageOff = _interopRequireDefault(require("./icons/IImageOff"));

var _IImageOffOutlined = _interopRequireDefault(require("./icons/IImageOffOutlined"));

var _IImageOutlined = _interopRequireDefault(require("./icons/IImageOutlined"));

var _IInbox = _interopRequireDefault(require("./icons/IInbox"));

var _IInboxOutlined = _interopRequireDefault(require("./icons/IInboxOutlined"));

var _IKeyboard = _interopRequireDefault(require("./icons/IKeyboard"));

var _IKeyboardOutlined = _interopRequireDefault(require("./icons/IKeyboardOutlined"));

var _ILanguage = _interopRequireDefault(require("./icons/ILanguage"));

var _ILevel = _interopRequireDefault(require("./icons/ILevel"));

var _ILevelOutlined = _interopRequireDefault(require("./icons/ILevelOutlined"));

var _ILink = _interopRequireDefault(require("./icons/ILink"));

var _ILock = _interopRequireDefault(require("./icons/ILock"));

var _ILockOutlined = _interopRequireDefault(require("./icons/ILockOutlined"));

var _ILogo = _interopRequireDefault(require("./icons/ILogo"));

var _IMax = _interopRequireDefault(require("./icons/IMax"));

var _IMedal = _interopRequireDefault(require("./icons/IMedal"));

var _IMedalOutlined = _interopRequireDefault(require("./icons/IMedalOutlined"));

var _IMin = _interopRequireDefault(require("./icons/IMin"));

var _IMobile = _interopRequireDefault(require("./icons/IMobile"));

var _IMobileOutlined = _interopRequireDefault(require("./icons/IMobileOutlined"));

var _IMoreHoriz = _interopRequireDefault(require("./icons/IMoreHoriz"));

var _IMoreVert = _interopRequireDefault(require("./icons/IMoreVert"));

var _IMultipleSelect = _interopRequireDefault(require("./icons/IMultipleSelect"));

var _IMultipleSelectOutlined = _interopRequireDefault(require("./icons/IMultipleSelectOutlined"));

var _INotifiction = _interopRequireDefault(require("./icons/INotifiction"));

var _INotifictionOutlined = _interopRequireDefault(require("./icons/INotifictionOutlined"));

var _INovel = _interopRequireDefault(require("./icons/INovel"));

var _INovelOutlined = _interopRequireDefault(require("./icons/INovelOutlined"));

var _IOutlined = _interopRequireDefault(require("./icons/IOutlined"));

var _IParagraphComment = _interopRequireDefault(require("./icons/IParagraphComment"));

var _IPause = _interopRequireDefault(require("./icons/IPause"));

var _IPen = _interopRequireDefault(require("./icons/IPen"));

var _IPenOutline = _interopRequireDefault(require("./icons/IPenOutline"));

var _IPerson = _interopRequireDefault(require("./icons/IPerson"));

var _IPickbook = _interopRequireDefault(require("./icons/IPickbook"));

var _IPickbookOutlined = _interopRequireDefault(require("./icons/IPickbookOutlined"));

var _IPin = _interopRequireDefault(require("./icons/IPin"));

var _IPinMap = _interopRequireDefault(require("./icons/IPinMap"));

var _IPinRemove = _interopRequireDefault(require("./icons/IPinRemove"));

var _IPlus = _interopRequireDefault(require("./icons/IPlus"));

var _IPoint = _interopRequireDefault(require("./icons/IPoint"));

var _IPointOutlined = _interopRequireDefault(require("./icons/IPointOutlined"));

var _IPolygonDown = _interopRequireDefault(require("./icons/IPolygonDown"));

var _IPolygonDownOutlined = _interopRequireDefault(require("./icons/IPolygonDownOutlined"));

var _IPolygonLeft = _interopRequireDefault(require("./icons/IPolygonLeft"));

var _IPolygonLeftOutlined = _interopRequireDefault(require("./icons/IPolygonLeftOutlined"));

var _IPolygonRight = _interopRequireDefault(require("./icons/IPolygonRight"));

var _IPolygonUp = _interopRequireDefault(require("./icons/IPolygonUp"));

var _IPolygonUpOutlined = _interopRequireDefault(require("./icons/IPolygonUpOutlined"));

var _IPrivilege = _interopRequireDefault(require("./icons/IPrivilege"));

var _IPrivilegeOutlined = _interopRequireDefault(require("./icons/IPrivilegeOutlined"));

var _IQuestion = _interopRequireDefault(require("./icons/IQuestion"));

var _IQuestionOutline = _interopRequireDefault(require("./icons/IQuestionOutline"));

var _IRadioSelected = _interopRequireDefault(require("./icons/IRadioSelected"));

var _IRadioSelectedOutlined = _interopRequireDefault(require("./icons/IRadioSelectedOutlined"));

var _IRadioUnselected = _interopRequireDefault(require("./icons/IRadioUnselected"));

var _IRankUp = _interopRequireDefault(require("./icons/IRankUp"));

var _IReadHistory = _interopRequireDefault(require("./icons/IReadHistory"));

var _IReadHistoryOutlined = _interopRequireDefault(require("./icons/IReadHistoryOutlined"));

var _IReadPage = _interopRequireDefault(require("./icons/IReadPage"));

var _IReadPageOutlined = _interopRequireDefault(require("./icons/IReadPageOutlined"));

var _IReadScroll = _interopRequireDefault(require("./icons/IReadScroll"));

var _IReadScrollOutlined = _interopRequireDefault(require("./icons/IReadScrollOutlined"));

var _IReadTap = _interopRequireDefault(require("./icons/IReadTap"));

var _IRedeem = _interopRequireDefault(require("./icons/IRedeem"));

var _IRefresh = _interopRequireDefault(require("./icons/IRefresh"));

var _IReport = _interopRequireDefault(require("./icons/IReport"));

var _IReportOutlined = _interopRequireDefault(require("./icons/IReportOutlined"));

var _ISearch = _interopRequireDefault(require("./icons/ISearch"));

var _ISetting = _interopRequireDefault(require("./icons/ISetting"));

var _ISettingOutlined = _interopRequireDefault(require("./icons/ISettingOutlined"));

var _IShare = _interopRequireDefault(require("./icons/IShare"));

var _IShareOutlined = _interopRequireDefault(require("./icons/IShareOutlined"));

var _IShowOff = _interopRequireDefault(require("./icons/IShowOff"));

var _IShowOffOutlined = _interopRequireDefault(require("./icons/IShowOffOutlined"));

var _IShowOn = _interopRequireDefault(require("./icons/IShowOn"));

var _IShowOnOutlined = _interopRequireDefault(require("./icons/IShowOnOutlined"));

var _ISmile = _interopRequireDefault(require("./icons/ISmile"));

var _ISmileOutlined = _interopRequireDefault(require("./icons/ISmileOutlined"));

var _ISpeaker = _interopRequireDefault(require("./icons/ISpeaker"));

var _IStar = _interopRequireDefault(require("./icons/IStar"));

var _IStarHalfLeft = _interopRequireDefault(require("./icons/IStarHalfLeft"));

var _IStarHalfLeftOutlined = _interopRequireDefault(require("./icons/IStarHalfLeftOutlined"));

var _IStarHalfRight = _interopRequireDefault(require("./icons/IStarHalfRight"));

var _IStarHalfRightOutlined = _interopRequireDefault(require("./icons/IStarHalfRightOutlined"));

var _IStarOutlined = _interopRequireDefault(require("./icons/IStarOutlined"));

var _IStoneEnergy = _interopRequireDefault(require("./icons/IStoneEnergy"));

var _IStonePower = _interopRequireDefault(require("./icons/IStonePower"));

var _ISwitch = _interopRequireDefault(require("./icons/ISwitch"));

var _ISync = _interopRequireDefault(require("./icons/ISync"));

var _ISyncOutlined = _interopRequireDefault(require("./icons/ISyncOutlined"));

var _ITap = _interopRequireDefault(require("./icons/ITap"));

var _ITapOutlined = _interopRequireDefault(require("./icons/ITapOutlined"));

var _IUnlock = _interopRequireDefault(require("./icons/IUnlock"));

var _IUnlockBatch = _interopRequireDefault(require("./icons/IUnlockBatch"));

var _IUnlockOutlined = _interopRequireDefault(require("./icons/IUnlockOutlined"));

var _IUpvote = _interopRequireDefault(require("./icons/IUpvote"));

var _IUpvoteOutlined = _interopRequireDefault(require("./icons/IUpvoteOutlined"));

var _IVoucher = _interopRequireDefault(require("./icons/IVoucher"));

var _IVoucherOutlined = _interopRequireDefault(require("./icons/IVoucherOutlined"));

var _IX = _interopRequireDefault(require("./icons/IX"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }